import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './sendMessageModal.scss';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import CloseIcon from '@/assets/steam/close.svg'
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import 'react-phone-input-2/lib/style.css';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useUpdateContact } from '../api/updateContact';
import { ModalFooter } from 'react-bootstrap';
import { useDeleteCity } from '../api/deleteCity';
import { Contact } from '../types/indes';
import { SelectedManagers } from '@/features/users/components/SelectedManagers';
import { showNotification } from '@/utils/notificationUtils';
import { useGetTemplates, useSendMessage } from '../api/sendMessage';
import Dropdown from 'react-bootstrap/Dropdown';

const SendMessage: VFC<{
  onConfirm: () => void;
  onClose: () => void;
  open: boolean;
  selectedContact?: any;
  allContacts?: Contact[];
  onRemoveUser: (data: any) => void;
}> = ({ onClose, onConfirm, open, selectedContact, allContacts, onRemoveUser }) => {
  const { user } = useAuth();
  const [message, setMessage] = useState<any>('');
  const [selectedContactList, setSelectedConatctList] = useState<Contact[]>([]);
  const [templates, setTemplates] = useState<any>([]);
  const [selectedTemplates, setSelectedTemplates] = useState<any>('');
  const useSendMessageMutation = useSendMessage();
  const useTemplates = useGetTemplates();


  useEffect(() => {
    getTemplates();
    if (selectedContact && allContacts) {
      const filteredContacts = allContacts.filter((item: any) =>
        selectedContact.includes(Number(item.id))
      );
      setSelectedConatctList(filteredContacts)

    }

  }, [selectedContact])


  const getTemplates = async () => {
    const res = await useTemplates.mutateAsync({
      id: null
    });
    if (res) {
      const filteredRes = res?.templates.filter((item: any) => item.status === 'APPROVED');
      setTemplates(filteredRes);
      if (res && res.templates && res.templates?.length > 0) {
        setSelectedTemplates(res.templates[0]);
      }
    }

  }

  const resetStates = () => {
    setMessage('');
    setSelectedConatctList([]);
  }
  const removeProvider = (provider: any) => {
    const filteredIndex = selectedContactList?.findIndex((sp) => {
      return sp.id === provider.id;
    });
    if (filteredIndex != undefined && filteredIndex >= 0) {
      selectedContactList?.splice(filteredIndex, 1);
      setSelectedConatctList([...selectedContactList as Contact[]]);
      onRemoveUser(provider)
    }
  };

  const getContent = () => {
    return (
      <div className="add-location-content">
        <div className="user-container mb-0">
          <h1>
            Select template <span>*</span>
          </h1>
        </div>
        <div className="user-first-last-div iscity-drp petsked-form mt-3 mb-3">

          <Dropdown className="new-figma-drop-down">
            <Dropdown.Toggle
              variant="success"
              className="drop-down-btn set-color dropdown-toggle"
              id="dropdown-basic"
            >
              {selectedTemplates ? selectedTemplates?.elementName : 'Select template'}
            </Dropdown.Toggle>
            <Dropdown.Menu className="Duration-drop-down">
              {templates?.map((item: any, index: any) => {
                return (
                  <Dropdown.Item
                    key={index}
                    onClick={() => {
                      setSelectedTemplates(item)
                    }}
                    eventKey={item.elementName}
                  >
                    <div className="menu-item-minutes">{item.elementName}</div>
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {selectedTemplates.elementName === 'steam' && <div className="user-container">
          <h1>
            Message <span>*</span>
          </h1>
          <div className='user-first-last-div'>
            <textarea
              className="new-cust-input message-input"
              placeholder="Type your message.."
              onChange={(ev) => setMessage(ev.target.value)}
              value={message}
            />
          </div>

        </div>}

        <div className="user-container">
          <h1>
            Selected contacts <span>*</span>
          </h1>
          <div className='mt-3'>
            <SelectedManagers
              removeProvider={removeProvider}
              selectedServiceProviders={selectedContactList}
              isShowPhone={true}
              showInstName={true}
            />
          </div>
        </div>

      </div>
    );
  };

  const validate = () => {
    let errorMessage = '';
    if (selectedTemplates.elementName === 'steam' && !message
    ) {
      errorMessage = 'Please enter message';
    } else if (selectedContactList && selectedContactList.length === 0) {
      errorMessage = 'Please select atleast 1 contact.';
    }
    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };

  return (
    <>
      <Modal
        show={open}
        onHide={() => { resetStates(), onClose() }}
        className={`steam-modal-dialog add-message-modal `}
        size="sm"

      >
        <Modal.Header closeButton >
          <div className="model-header-tab">
            <div className="modal-header-title">
              {'Send message'}
            </div>
            <div className="modal-header-desc">
              {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body >{getContent()}</Modal.Body>
        <ModalFooter>
          <div className={`btn-container end`}>
            <button
              className={`steam-button button-dark set-height`}
              onClick={async () => {
                if (validate() && selectedContactList) {
                  //const filterNumbers = selectedContactList.map((item: any) => item.phone);
                  const filterNumbers = selectedContactList.map((item: any) =>
                    item.phone.startsWith("+91") ? item.phone.substring(3) : item.phone
                  );
                  await useSendMessageMutation.mutateAsync({
                    contacts: filterNumbers ? filterNumbers : [],
                    message,
                    template: selectedTemplates?.elementName,
                    attributeName: selectedTemplates?.customParams && selectedTemplates?.customParams.length > 0 && selectedTemplates?.customParams[0].paramName,

                  });
                  resetStates();
                  onConfirm();
                }

              }}
            //disabled={useAddInstituteMutation?.isLoading}
            >
              <span>{'Send'}</span>
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};




export default SendMessage;
